// src/modules/IntegratedMessaging/hooks/useCouriers.ts
import { useQuery } from '@tanstack/react-query';
import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services';
import { CouriersApiAdapter } from '../adapters/CouriersApiAdapter';
import { Courier } from '../models/IntegratedMessaging';

const httpClient = createHttpClient(apiClientWH);
const adapter = new CouriersApiAdapter(httpClient);

export const useCouriers = () => {
  return useQuery<Courier[], Error>({
    queryKey: ['couriers'],
    queryFn: () => adapter.getCouriers(),
    staleTime: 10 * 60 * 1000,
    enabled: true,
  });
};
